import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

// استایل‌های سفارشی برای انیمیشن تب‌ها
const tabTransition = "transition-all duration-300 ease-in-out";

// آرایه‌های تب‌ها را خارج از کامپوننت تعریف کنید تا همیشه ثابت بمانند
const upTabs = ["Solo", "Doubles", "Trio", "Squad", "4v4"];
const downTabs = ["Kills", "Wins", "WinStreak", "Level", "Final Kills"];

export default function ScoreBoard() {
  // استیت برای نگهداری تب فعال بالا و پایین
  const [activeUpTab, setActiveUpTab] = useState(upTabs[0]);
  const [activeDownTab, setActiveDownTab] = useState(downTabs[0]);

  // رفرنس برای تب‌های بالا و پایین جهت تعیین موقعیت انیمیشن
  const upTabRefs = useRef([]);
  const downTabRefs = useRef([]);
  const [upIndicatorStyle, setUpIndicatorStyle] = useState({});
  const [downIndicatorStyle, setDownIndicatorStyle] = useState({});

  // state users
  const [users, setUsers] = useState([
    {
      id: 1,
      name: "esi1",
      icon: "./images/players/player1.png",
      score: Math.floor(Math.random() * 1000),
    },
    {
      id: 2,
      name: "esi2",
      icon: "./images/players/player2.png",
      score: Math.floor(Math.random() * 1000),
    },
    {
      id: 3,
      name: "esi3",
      icon: "./images/players/player3.png",
      score: Math.floor(Math.random() * 1000),
    },
    {
      id: 4,
      name: "esi4",
      icon: "./images/players/player4.png",
      score: Math.floor(Math.random() * 1000),
    },
    {
      id: 5,
      name: "esi5",
      icon: "./images/players/player5.png",
      score: Math.floor(Math.random() * 1000),
    },
    {
      id: 6,
      name: "esi6",
      icon: "./images/players/player6.png",
      score: Math.floor(Math.random() * 1000),
    },
    {
      id: 7,
      name: "esi7",
      icon: "./images/players/player7.png",
      score: Math.floor(Math.random() * 1000),
    },
    {
      id: 8,
      name: "esi8",
      icon: "./images/players/player8.png",
      score: Math.floor(Math.random() * 1000),
    },
    {
      id: 9,
      name: "esi9",
      icon: "./images/players/player9.png",
      score: Math.floor(Math.random() * 1000),
    },
  ]);
  // هندل کردن حرکت انیمیشن برای تب‌های بالا
  useEffect(() => {
    const idx = upTabs.indexOf(activeUpTab);
    const node = upTabRefs.current[idx];
    if (node) {
      setUpIndicatorStyle({
        left: node.offsetLeft + "px",
        width: node.offsetWidth + "px",
        height: node.offsetHeight + "px",
      });
    }
  }, [activeUpTab]);

  // هندل کردن حرکت انیمیشن برای تب‌های پایین
  useEffect(() => {
    const idx = downTabs.indexOf(activeDownTab);
    const node = downTabRefs.current[idx];
    if (node) {
      setDownIndicatorStyle({
        left: node.offsetLeft + "px",
        width: node.offsetWidth + "px",
        height: node.offsetHeight + "px",
      });
    }
  }, [activeDownTab]);

  return (
    <section className="relative z-10 px-3.5">
      <div className="container md:mt-32 mt-4 relative z-20">
        <div
          className="flex flex-col md:flex-row justify-between relative z-30 items-center gap-y-2"
          style={{ direction: "rtl" }}
        >
          {/* Right title */}
          <div className="flex justify-center md:justify-start pt-10 md:text-4xl text-xl text-white font-DanaDemiBold">
            <div className="flex justify-center md:justify-start">
              جدول امتیازات{" "}
              <span className="text-[#D4FE00] inline-flex flex-col gap-y-2">
                کاربران{" "}
              </span>
            </div>
          </div>
          {/* Left buttons */}
          <div
            className="flex flex-col text-white gap-y-2"
            style={{ direction: "ltr" }}
          >
            {/* Up Tabs */}
            <div className="relative flex gap-x-1.5 child:w-fit child:md:text-sm/10 child:text-[11px]/8 child:px-3 child:bg-[#181b24] child:rounded-lg child:max-h-[33px] child:cursor-pointer">
              {/* Indicator */}
              <span
                className="absolute bg-[#D4FE00] rounded-lg z-0"
                style={{
                  ...upIndicatorStyle,
                  transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
                  top: 0,
                  bottom: 0,
                  opacity: 0.2,
                  pointerEvents: "none",
                }}
              />
              {upTabs.map((tab, idx) => (
                <div
                  key={tab}
                  ref={(el) => (upTabRefs.current[idx] = el)}
                  className={
                    (tab === activeUpTab
                      ? "active-tab text-black font-DanaDemiBold "
                      : "text-white ") +
                    "relative z-10 " +
                    tabTransition
                  }
                  onClick={() => setActiveUpTab(tab)}
                  style={{
                    background:
                      tab === activeUpTab ? "rgba(212,254,0,0.15)" : "#181b24",
                  }}
                >
                  {tab}
                </div>
              ))}
            </div>
            {/* Down Tabs */}
            <div className="relative flex gap-x-1.5 child:w-fit child:md:text-sm/10 child:text-[11px]/8 child:px-3 child:bg-[#181b24] child:rounded-lg child:max-h-[33px] child:cursor-pointer">
              {/* Indicator */}
              <span
                className="absolute bg-[#D4FE00] rounded-lg z-0"
                style={{
                  ...downIndicatorStyle,
                  transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
                  top: 0,
                  bottom: 0,
                  opacity: 0.2,
                  pointerEvents: "none",
                }}
              />
              {downTabs.map((tab, idx) => (
                <div
                  key={tab}
                  ref={(el) => (downTabRefs.current[idx] = el)}
                  className={
                    (tab === activeDownTab
                      ? "active-tab text-black font-DanaDemiBold "
                      : "text-white ") +
                    "relative z-10 " +
                    tabTransition
                  }
                  onClick={() => setActiveDownTab(tab)}
                  style={{
                    background:
                      tab === activeDownTab
                        ? "rgba(212,254,0,0.15)"
                        : "#181b24",
                  }}
                >
                  {tab}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Players */}
        <main className="text-white mt-5">
          {users &&
            users.map((user, idx) => {
              return (
                <div
                  className={`flex justify-between items-center w-full rounded-lg py-2.5 px-2 ${
                    idx % 2 === 0 ? "bg-lightGray" : "bg-darkGray"
                  }`}
                  key={user.id}
                >
                  {/* Name and id section - Left*/}
                  <div className="flex gap-x-2 items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5.74 16c.11-.49-.09-1.19-.44-1.54l-2.43-2.43c-.76-.76-1.06-1.57-.84-2.27.23-.7.94-1.18 2-1.36l3.12-.52c.45-.08 1-.48 1.21-.89l1.72-3.45C10.58 2.55 11.26 2 12 2s1.42.55 1.92 1.54l1.72 3.45c.13.26.4.51.69.68L5.56 18.44c-.14.14-.38.01-.34-.19L5.74 16ZM18.7 14.462c-.36.36-.56 1.05-.44 1.54l.69 3.01c.29 1.25.11 2.19-.51 2.64a1.5 1.5 0 0 1-.9.27c-.51 0-1.11-.19-1.77-.58l-2.93-1.74c-.46-.27-1.22-.27-1.68 0l-2.93 1.74c-1.11.65-2.06.76-2.67.31-.23-.17-.4-.4-.51-.7l12.16-12.16c.46-.46 1.11-.67 1.74-.56l1.01.17c1.06.18 1.77.66 2 1.36.22.7-.08 1.51-.84 2.27l-2.42 2.43Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <div className="flex items-center gap-x-4">
                      <span className="font-mono text-2xl">{user.id}</span>
                      <img
                        src={user.icon}
                        className="w-10 h-10 rounded-lg"
                        alt=""
                      />
                      <h3>{user.name}</h3>
                    </div>
                  </div>
                  {/* Right Section */}
                  <span className="font-mono text-lg">{user.score}</span>
                </div>
              );
            })}
        </main>
      </div>
    </section>
  );
}
